<template>
  <a-modal
    :visible="show"
    :title="$t('page_ops_customer_machine_config')"
    :cancel-text="$t('cancel')"
    :ok-text="$t('ok')"
    @cancel="close"
    @ok="saves"
  >
    <div class="box">
      <machine-fie-list
        :fileList="attachFilesList"
        @saveList="(value) => saveFile(value)"
      ></machine-fie-list>
    </div>
  </a-modal>
</template>

<script>
import {
  CreateOrUpdateMachineDTO,
  MachineServiceProxy
} from '@/service-proxies/app-v2/workStation.service-proxies'
import { ServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'

const machineSrvProxy = new MachineServiceProxy()
const sProxy = new ServiceProxy()

import MachineFieList from '../../machine/components/MachineFieList.vue'
export default {
  name: 'Customdown',
  components: {
    MachineFieList
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    device: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    show: {
      handler() {
        if (this.show && this.device && this.device.id) {
          sProxy.getBizAttachListUsingGET(this.device.id, 'work_station_of_machine').then((res) => {
            this.attachFilesList = res.data
          })

          machineSrvProxy.getForEdit(this.device.id).then((res) => {
            this.record = res
            // this.title = this.record.id ?'编辑机床':'新增机床';
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      fileList: [],
      record: {},
      attachFilesList: []
    }
  },
  methods: {
    saveFile(list) {
      this.fileList = list
    },
    saves() {
      const dto = new CreateOrUpdateMachineDTO()
      dto.init(this.record)
      dto.attachFiles = this.fileList.map((res) => {
        return res.attachId
      })
      console.log(dto)
      machineSrvProxy.createOrUpdateMachine(dto).then((res) => {
        this.$message.success($t('page_ops_customer_saved_success'))
        this.$emit('update')
      })
    },
    close() {
      this.$emit('update')
    }
  }
}
</script>

<style scoped lang="less">
.box {
  // background-image: url('../../public/img/home/windows.png');
  background-size: 100% 100%;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 4.8vh;
    padding: 0 2vh;

    span {
      color: #7ecfef;
      font-size: 2vh;
    }

    img {
      width: 2vh;
      height: 2vh;
      cursor: pointer;
    }
  }

  &-content {
    padding: 2vh 1.5vw 0;
    height: calc(~'100% - 0.8vh - 8vh');
    overflow: auto;
    .box-downcontent {
      padding: 5px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
